import { render, staticRenderFns } from "./ConversationInfo.vue?vue&type=template&id=cfb8ede6&scoped=true&"
import script from "./ConversationInfo.vue?vue&type=script&lang=js&"
export * from "./ConversationInfo.vue?vue&type=script&lang=js&"
import style0 from "./ConversationInfo.vue?vue&type=style&index=0&id=cfb8ede6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb8ede6",
  null
  
)

export default component.exports